import { render, staticRenderFns } from "./qiniu.vue?vue&type=template&id=14fbbbc4&"
import script from "./qiniu.vue?vue&type=script&lang=js&"
export * from "./qiniu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "qiniu.vue"
export default component.exports